import styled from 'styled-components';
import { colorWhite } from 'theme/theme-helper-selectors';

export const Wrapper = styled.div`
    border-radius: 8px;
    padding: 4px;
    box-shadow: 0px 10px 32px -4px #18274b1a;
    background-color: ${colorWhite};
`;
